module.exports = __webpack_public_path__ + "static/plan-s5-06e261aa8a744dd2ac6447ac2c86bec3.jpg";